var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLogoTeams32 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#svg-public/img/icons/logo_teams_32.svg__clip0_12344_26383)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 15.2137C0 8.04221 0 4.45649 2.22825 2.22825C4.45649 0 8.04221 0 15.2137 0H16.7863C23.9578 0 27.5435 0 29.7717 2.22825C32 4.45649 32 8.04221 32 15.2137V16.7863C32 23.9578 32 27.5435 29.7717 29.7717C27.5435 32 23.9578 32 16.7863 32H15.2137C8.04221 32 4.45649 32 2.22825 29.7717C0 27.5468 0 23.9611 0 16.7863V15.2137Z",
  fill: "#0077FF"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.1654 17.8412C15.5541 19.2299 15.5541 21.4814 14.1654 22.87L11.7485 25.287C10.3598 26.6757 8.1083 26.6757 6.71963 25.287C5.33095 23.8983 5.33095 21.6468 6.71963 20.2582L9.1366 17.8412C10.5253 16.4525 12.7768 16.4525 14.1654 17.8412Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.71963 6.72151C8.1083 5.33283 10.3598 5.33283 11.7485 6.7215L14.1654 9.13847C15.5541 10.5271 15.5541 12.7786 14.1654 14.1673C12.7768 15.556 10.5253 15.556 9.1366 14.1673L6.71963 11.7503C5.33096 10.3617 5.33096 8.11018 6.71963 6.72151Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.8371 17.8412C19.2258 16.4525 21.4773 16.4525 22.866 17.8412L25.2829 20.2582C26.6716 21.6468 26.6716 23.8983 25.2829 25.287C23.8943 26.6757 21.6428 26.6757 20.2541 25.287L17.8371 22.87C16.4485 21.4814 16.4485 19.2299 17.8371 17.8412Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M25.2829 6.72151C26.6716 8.11018 26.6716 10.3617 25.2829 11.7503L22.866 14.1673C21.4773 15.556 19.2258 15.556 17.8371 14.1673C16.4485 12.7786 16.4485 10.5271 17.8371 9.13847L20.2541 6.72151C21.6428 5.33283 23.8943 5.33283 25.2829 6.72151Z",
  fill: "#00D3E6"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "svg-public/img/icons/logo_teams_32.svg__clip0_12344_26383"
}, /*#__PURE__*/React.createElement("rect", {
  width: 32,
  height: 32,
  fill: "white"
})))));
export { SvgLogoTeams32 as ReactComponent };